import { Text, useMainContext } from '../../../../modules/Dashboard'
import { usePredictContext } from '../../context/PredictContextProvider'
import { useNavigate } from 'react-router-dom'
import LeftIcon from '../../../../components/icons/Left'

// Icons
import { ReactComponent as Ellipse } from '../../assets/methods/card-ellipse.svg'
import AssistantIcon from '../AssistantIcon'
import LockedAssistant from '../LockedAssistant'

const ForexAnalyzers = ({ loading, assistants = [] }) => {
    const {
        main: { lang },
    } = useMainContext()
    const { assistant, isLocked } = usePredictContext()
    const navigate = useNavigate()

    const handleSelectAssistant = (method) => {
        if (isLocked) return
        assistant.setAssistant(method)
        navigate(`/analyze/assistant/forex?step=tickers`)
    }


    return (
        <div>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 min-h-[150px]">
                {loading
                    ? // Skeletons while loading
                    Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)
                    : //  Dynamic assistant cards
                    assistants.map((assistant, index) => (
                        <div
                            key={assistant.value || index}
                            onClick={() => handleSelectAssistant(assistant)}
                            className="relative shine-btn overflow-hidden bg-[#1E1533] border border-purpleBorderDark rounded-2xl cursor-pointer transition-all hover:scale-[1.02] group"
                        >
                            {/* If Is Locked */}
                            <LockedAssistant />

                            {/* Card Content */}
                            <div className="flex flex-col gap-2 relative z-[2] h-full p-6">
                                <div className='flex items-center gap-2'>
                                    <AssistantIcon assistantValue={assistant.value} size={45} />
                                    <Text tid={assistant.label} className="text-xl !text-white rtl:font-bold" />
                                </div>
                                <Text tid={`${assistant?.description}`} className="text-sm opacity-80" />


                                {/* Show cost types */}
                                {/* {assistant.responseType && (
                                    <div className="flex flex-wrap gap-2 mt-3">
                                        {assistant.responseType.map((res, i) => (
                                            <span
                                                key={i}
                                                className="text-xs bg-[#3B3950] px-2 py-1 rounded-full"
                                            >
                                                {res.type}: {res.cost} DEX
                                            </span>
                                        ))}
                                    </div>
                                )} */}

                                <div className='absolute right-0 top-0 h-full'>
                                    <Ellipse height={"100%"} />
                                </div>

                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default ForexAnalyzers

// Skeleton loader
const SkeletonCard = () => (
    <div className="bg-[#262433] rounded-lg p-4 h-[200px] flex flex-col justify-between">
        <div className="animate-pulse h-6 bg-gray-600 rounded w-3/4"></div>
        <div className="animate-pulse h-4 bg-gray-600 rounded w-full mt-2"></div>
        <div className="animate-pulse h-4 bg-gray-600 rounded w-5/6 mt-2"></div>
        <div className="animate-pulse h-4 bg-gray-600 rounded w-1/3 mt-auto"></div>
    </div>
)